var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 25 24","width":"25","height":"24","stroke":""}},[_c('path',{attrs:{"d":"M8.786 6.838a6.276 6.276 0 1 0 8.876 8.876 6.276 6.276 0 0 0-8.876-8.876M5.5 19l3.29-3.29"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }